import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ConstructionServices() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" dir="ltr">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link className="flex items-center" to="/">
              <img 
                alt="VIPA Trading Company" 
                className="h-12 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/">
                Home
              </Link>
              <div className="relative">
                <button 
                  className="text-[#E71B25] hover:text-[#d11620] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Services
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000]">
                    <div className="py-2">
                      <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Construction & Roads
                      </Link>
                      <Link to="/services/oil" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Oil & Gas
                      </Link>
                      <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Gold Trading
                      </Link>
                      <Link to="/services/defense" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Defense Systems
                      </Link>
                      <Link to="/consultation" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Consulting
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/about">
                About Us
              </Link>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/contact">
                Contact
              </Link>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                >
                  Contact Us
                </button>
              </Link>
            </div>

            <button 
              className="lg:hidden text-[#595A5C] cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-[#596A78] to-[#4a5661] overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-60"
            style={{ 
              backgroundImage: `url(https://public.readdy.ai/ai/img_res/f12303714748d3f7047a44a1d96dfdef.jpg)` 
            }}
          ></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              {/* Breadcrumbs */}
              <div className="flex items-center justify-center space-x-2 text-sm mb-8 opacity-90">
                <Link to="/" className="hover:text-white/80 transition-colors">Home</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span>Services</span>
                <i className="ri-arrow-right-s-line"></i>
                <span>Construction & Roads</span>
              </div>
              
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Construction & Roads
              </h1>
              <p className="text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto mb-10">
                We specialize in executing infrastructure and road projects to the highest quality standards — from earthwork and grading to integrated networks and smart-city site management.
              </p>
              
              {/* Hero Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link to="/contact">
                  <button 
                    type="button" 
                    className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-[#E71B25] text-white hover:bg-[#d11620] shadow-lg hover:shadow-xl px-8 py-4 text-lg"
                  >
                    Get Quote
                  </button>
                </Link>
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-white text-white hover:bg-white hover:text-[#596A78] px-8 py-4 text-lg"
                  onClick={() => document.getElementById('scope')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  View Service
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Service Scope */}
        <section id="scope" className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-8">Our Service Scope</h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Earthwork and excavation
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Plot and road leveling & grading
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Subgrade / subbase / base layers
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Asphalt paving & road markings
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Curbs, sidewalks & interlock
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Stormwater & sewage networks
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Potable water networks
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Power distribution & street lighting
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Telecom / fiber-optic networks
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mt-1 mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Landscaping & site development
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/953a8c78537cfa9dd043a85b6fa49fd1.jfif"
                  alt="Construction Services"
                  className="w-full h-auto rounded-xl shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Compliance & Quality */}
        <section className="py-20 bg-[#F7F7F7]">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Compliance & Quality</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-clipboard-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Kuwait Specifications</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Full compliance with KFD/MPW specs and national standards
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">QA/QC Systems</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Integrated quality assurance and control across all phases
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-time-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">On-time Delivery</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Committed to delivering projects within agreed timelines
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose VIPA */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Why Choose VIPA?</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Dedicated Support</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Specialized client support until final handover
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-trophy-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Proven Track Record</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Delivered for government & private sectors in Kuwait
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lightbulb-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Advanced Technical Expertise</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Modern methods and qualified teams for top results
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 bg-[#E71B25] text-white">
          <div className="container mx-auto px-4 max-w-4xl text-center">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">Ready to start your project?</h2>
            <p className="text-xl mb-8 leading-relaxed">
              Contact us today to get a professional consultation on your construction project and transform your vision into reality with the highest quality standards.
            </p>
            <Link to="/contact">
              <button 
                type="button" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] hover:bg-gray-100 shadow-sm hover:shadow-md px-8 py-4 text-lg"
              >
                Request Quote
              </button>
            </Link>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#2B2C2E] text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2 space-y-6">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center mr-4">
                    <img 
                      alt="VIPA Trading Company" 
                      className="h-16 w-auto" 
                      src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                    />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">VIPA Trading Company</h2>
                    <p className="text-[#E71B25] text-sm font-medium">شركة فيبا التجارية</p>
                  </div>
                </div>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A leading Kuwaiti multi-activity company that works in engineering, oil, trading, armament, and consulting with the highest international standards.
                </p>
                <div className="space-y-3">
                  <a href="mailto:info@vipatradingco.com" className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#E71B25] transition-colors">
                      <i className="ri-mail-line text-sm"></i>
                    </div>
                    info@vipatradingco.com
                  </a>
                  <div className="text-gray-300 text-base inline-flex items-center">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-phone-line text-sm"></i>
                    </div>
                    Kuwait
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-[#E71B25] hover:text-[#d11620] transition-colors text-base cursor-pointer block group" to="/services/construction"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Construction</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/oil"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Oil & Gas</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/trading"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Trading</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/armament"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Armament</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/consulting"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Consulting</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Home</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/about"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>About Us</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/contact"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Contact</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/careers"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Careers</Link></li>
              </ul>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-600">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <p className="text-gray-400 text-sm">© 2025 VIPA Trading Company — All rights reserved.</p>
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center gap-4">
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                </div>
                <div className="flex items-center gap-3 md:border-l md:border-gray-600 md:pl-4">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-medal-line text-[#E71B25]"></i>
                    <span>ISO 9001</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-shield-check-line text-[#E71B25]"></i>
                    <span>HSE Certified</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
